module.exports = __webpack_public_path__ + "label-good.233c4963.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/label-good.svg
// module id = zkR9
// module chunks = 0